import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, TS_DragAndDrop } from '@nu-art/thunderstorm-frontend/index';
class PgComponent extends ComponentSync {
    deriveStateFromProps() {
    }
    render() {
        return _jsx(LL_V_L, { children: _jsx(TS_DragAndDrop, { validate: TS_DragAndDrop.validateFilesBySuffix('js'), onChange: (acceptedFiles, rejectedFiles) => {
                    this.logInfo(acceptedFiles, rejectedFiles);
                } }) });
    }
}
export const PgDev_DragAndDrop = { name: 'PG - DragAndDrop', key: 'drag-and-drop', renderer: PgComponent };
